// Appends sizing/compression params to Unsplash/Pexels URLs to avoid loading
// full-resolution images (a major perceived-speed win). Other URLs pass through.
export function sized(url, w = 800, q = 70) {
  if (!url) return url;
  try {
    if (url.includes('images.unsplash.com')) {
      const sep = url.includes('?') ? '&' : '?';
      return `${url}${sep}auto=format&fit=crop&w=${w}&q=${q}`;
    }
    if (url.includes('images.pexels.com')) {
      const sep = url.includes('?') ? '&' : '?';
      // strip existing size params lightly by just appending; pexels honors last
      return `${url}${sep}auto=compress&cs=tinysrgb&w=${w}`;
    }
    return url;
  } catch (e) {
    return url;
  }
}
